/**
 * Custom Hero Effects
 * - Cursor follow: translates photo containers to follow cursor
 * - Scroll slide-up: photos drift upward as page scrolls
 * Both effects share per-photo state so transforms combine correctly.
 */
(function () {
  var CURSOR_MAX_PX = 22;
  var CURSOR_LERP = 0.06;
  var SLIDE_RATE = 0.18;

  function initSection(section) {
    // Honour the OS reduced-motion setting: no cursor follow, no parallax
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var isMobile = window.matchMedia('(max-width: 767px)').matches;

    var hasCursor = !isMobile && section.hasAttribute('data-custom-hero-cursor-follow');
    var hasSlide = section.hasAttribute('data-custom-hero-slide-up');
    if (!hasCursor && !hasSlide) return;

    var photos = section.querySelectorAll('[data-custom-hero-photo]');
    if (!photos.length) return;

    // Per-photo state
    var state = [];
    for (var p = 0; p < photos.length; p++) {
      state.push({
        el: photos[p],
        cursorDepth: p === 0 ? 1 : 0.5,
        slideRate: p === 0 ? SLIDE_RATE : SLIDE_RATE * 0.6,
        curX: 0, curY: 0,
        slideY: 0
      });
    }

    var cursorTargetX = 0, cursorTargetY = 0;
    var cursorCurrentX = 0, cursorCurrentY = 0;
    var cursorActive = false;
    var needsRender = false;

    function render() {
      if (hasCursor) {
        cursorCurrentX += (cursorTargetX - cursorCurrentX) * CURSOR_LERP;
        cursorCurrentY += (cursorTargetY - cursorCurrentY) * CURSOR_LERP;
        cursorActive = Math.abs(cursorTargetX - cursorCurrentX) > 0.1 ||
                       Math.abs(cursorTargetY - cursorCurrentY) > 0.1;
      }

      var scrollY = hasSlide ? window.pageYOffset : 0;

      for (var i = 0; i < state.length; i++) {
        var s = state[i];
        var tx = hasCursor ? cursorCurrentX * s.cursorDepth : 0;
        var ty = hasCursor ? cursorCurrentY * s.cursorDepth : 0;
        if (hasSlide) ty += -(scrollY * s.slideRate);
        s.el.style.transform = 'translate(' + tx.toFixed(2) + 'px, ' + ty.toFixed(1) + 'px)';
      }

      if (cursorActive) {
        requestAnimationFrame(render);
      } else {
        needsRender = false;
      }
    }

    function scheduleRender() {
      if (!needsRender) {
        needsRender = true;
        requestAnimationFrame(render);
      }
    }

    if (hasCursor) {
      section.addEventListener('mousemove', function (e) {
        var rect = section.getBoundingClientRect();
        cursorTargetX = ((e.clientX - rect.left) / rect.width - 0.5) * CURSOR_MAX_PX * 2;
        cursorTargetY = ((e.clientY - rect.top) / rect.height - 0.5) * CURSOR_MAX_PX * 2;
        cursorActive = true;
        scheduleRender();
      });

      section.addEventListener('mouseleave', function () {
        cursorTargetX = 0;
        cursorTargetY = 0;
        cursorActive = true;
        scheduleRender();
      });
    }

    if (hasSlide) {
      window.addEventListener('scroll', function () {
        scheduleRender();
      }, { passive: true });

      // Set initial position
      scheduleRender();
    }
  }

  /**
   * Title fit (phones and tablets, <= 1023px): the "Fill the width" title size.
   * CSS cannot know how long the words are, so the real heading is sized by
   * binary search until its longest word just fits the text column (the
   * heading wraps at spaces, so horizontal overflow means one word is too
   * wide). Measuring the rendered heading keeps the stylistic alternates and
   * letter-spacing exact. Floor: the tier's CSS size; ceiling: the desktop
   * size from the section's data attribute. Re-run when the webfont lands
   * (the fallback face has different widths) and when the width changes.
   */
  var FIT_MAX_WIDTH = 1023;

  function fitTitle(section) {
    var title = section.querySelector('h1[class^="custom-hero__title-"]');
    if (!title) return;
    var all = section.querySelectorAll('.' + title.className.split(' ')[0]);
    for (var a = 0; a < all.length; a++) all[a].style.fontSize = '';
    if (window.innerWidth > FIT_MAX_WIDTH) return;
    var floor = parseFloat(getComputedStyle(title).fontSize) || 36;
    var ceiling = parseFloat(section.getAttribute('data-custom-hero-title-max')) || floor;
    if (ceiling <= floor || !title.clientWidth) return;
    var lo = floor, hi = ceiling;
    for (var i = 0; i < 9; i++) {
      var mid = (lo + hi) / 2;
      title.style.fontSize = mid + 'px';
      if (title.scrollWidth > title.clientWidth + 1) hi = mid; else lo = mid;
    }
    var size = Math.floor(lo) + 'px';
    // the title may have a normal "ghost" copy for the phone/tablet blend amount; size it alike
    var copies = section.querySelectorAll('.' + title.className.split(' ')[0]);
    for (var c = 0; c < copies.length; c++) copies[c].style.fontSize = size;
  }

  function initTitleFit() {
    var sections = document.querySelectorAll('[data-custom-hero-title-fit]');
    if (!sections.length) return;
    var run = function () {
      for (var i = 0; i < sections.length; i++) fitTitle(sections[i]);
    };
    run();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
    if (!window.__customHeroFitBound) {
      window.__customHeroFitBound = true;
      var lastWidth = window.innerWidth, timer = null;
      window.addEventListener('resize', function () {
        if (window.innerWidth === lastWidth) return;
        lastWidth = window.innerWidth;
        clearTimeout(timer);
        timer = setTimeout(initTitleFit, 150);
      });
    }
  }

  function init() {
    var sections = document.querySelectorAll('[data-custom-hero-cursor-follow]:not([data-hero-fx-init]), [data-custom-hero-slide-up]:not([data-hero-fx-init])');
    for (var i = 0; i < sections.length; i++) {
      sections[i].setAttribute('data-hero-fx-init', '');
      initSection(sections[i]);
    }
    initTitleFit();
  }

  document.addEventListener('shopify:section:load', init);

  document.addEventListener('page:loaded', init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
